<template>
    <div class="all">
      <Head></Head>
      <div class="ArticleDetails">
        <div class="ArticleDetails-title">
          <p>
            {{wenzhang.title}}
          </p>
          <span>{{wenzhang.add_time | filterDate('yyyy年MM月dd日 hh:mm')}}</span>
        </div>
        <div v-html="wenzhang.content">

        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import {getnewsing} from "../api/index";
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
    export default {
        name: "ArticleDetails",
      components:{
        Pagetail,Head
      },
      data(){
        return{
          wenzhang:{},
        }
      },
      mounted() {
          this.init()
      },
      methods:{
          init(){
            getnewsing({id:this.$route.query.id}).then(res=>{
              this.wenzhang = res.result
            })
          }
      }
    }
</script>

<style scoped lang="less">
  .ArticleDetails{
    width: 1200px;
    margin: 0 auto;
  }
  .ArticleDetails-title{
    text-align: center;
    padding: 30px 0;
    p{
      font-size: 18px;
    }
    span{
      color: #ccc;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetails.vue